/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BranchDto
 */
export interface BranchDto {
    /**
     * Branch ID (UUID)
     * @type {string}
     * @memberof BranchDto
     */
    id?: string;
    /**
     * Branch address
     * @type {string}
     * @memberof BranchDto
     */
    address: string;
    /**
     * Street name
     * @type {string}
     * @memberof BranchDto
     */
    street: string;
    /**
     * City name
     * @type {string}
     * @memberof BranchDto
     */
    city: string;
    /**
     * State name
     * @type {string}
     * @memberof BranchDto
     */
    state: string;
    /**
     * ZIP code
     * @type {string}
     * @memberof BranchDto
     */
    zip: string;
    /**
     * Branch email address
     * @type {string}
     * @memberof BranchDto
     */
    emailAddress: string;
    /**
     * Branch primary phone number
     * @type {string}
     * @memberof BranchDto
     */
    primaryPhoneNumber: string;
    /**
     * Branch fax number
     * @type {string}
     * @memberof BranchDto
     */
    faxNumber?: string;
    /**
     * Number of staff assigned to this branch
     * @type {number}
     * @memberof BranchDto
     */
    staffCount?: number;
}

/**
 * Check if a given object implements the BranchDto interface.
 */
export function instanceOfBranchDto(value: object): value is BranchDto {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('primaryPhoneNumber' in value) || value['primaryPhoneNumber'] === undefined) return false;
    return true;
}

export function BranchDtoFromJSON(json: any): BranchDto {
    return BranchDtoFromJSONTyped(json, false);
}

export function BranchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'address': json['address'],
        'street': json['street'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'emailAddress': json['emailAddress'],
        'primaryPhoneNumber': json['primaryPhoneNumber'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
        'staffCount': json['staffCount'] == null ? undefined : json['staffCount'],
    };
}

export function BranchDtoToJSON(json: any): BranchDto {
    return BranchDtoToJSONTyped(json, false);
}

export function BranchDtoToJSONTyped(value?: BranchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'address': value['address'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'emailAddress': value['emailAddress'],
        'primaryPhoneNumber': value['primaryPhoneNumber'],
        'faxNumber': value['faxNumber'],
        'staffCount': value['staffCount'],
    };
}

